import type PerformerModel from "parog-web/models/performer";
import { performerRetrieve } from "parog-web/utils/dmp-utils";
import type { Execution, Performer, Section } from "./abstract-dmp-parser";
import AbstractDmpParser from "./abstract-dmp-parser";

interface MedicalActExecution extends Execution {
  performer: PerformerModel;
}

export default class MedicalActDmpParser extends AbstractDmpParser {
  journalEventClassName = "MedicalActRefundedJournalEvent";

  canParse(section: Section): boolean {
    const code = section.code?._attributes?.code;
    const title = section.title?._text;
    return code == "29554-3" && title == "Soins médicaux et dentaires";
  }

  parse(section: Section): Array<MedicalActExecution> {
    return this.getEntries(section)
      .map(entry => {
        const procedure = entry.procedure;
        if (!procedure) return;

        const source = procedure?.code?._attributes;

        if (source.nullFlavor || source.codeSystem == "1.2.250.1.213.2.63")
          return;

        const occurredAt = this.parseOccurredAt(procedure);
        if (!occurredAt) return;

        let procedureSourceConcept;

        if (source.codeSystem == "1.2.250.1.215.200.3.3") {
          procedureSourceConcept = "NGAP";
        } else if (source.codeSystem == "1.2.250.1.215.200.3.4") {
          procedureSourceConcept = "CCAM";
        } else {
          return;
        }

        const procedureSourceValue = source.code;
        const procedureSourceLabel = source.displayName;

        const performer = (procedure?.performer as Performer)?.assignedEntity;
        if (!performer) return;

        if (
          occurredAt &&
          procedureSourceConcept &&
          procedureSourceValue &&
          procedureSourceLabel
        ) {
          return {
            occurredAt,
            procedureSourceConcept,
            procedureSourceValue,
            procedureSourceLabel,
            performer: performerRetrieve(entry.procedure?.performer)
          };
        }

        return undefined;
      })
      .filter(Boolean) as MedicalActExecution[];
  }
}
